import axios from 'axios';
import config from '../config';

// Create an axios instance with default config
const api = axios.create({
  // Use relative URLs for API requests to leverage Nginx proxy
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token if available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('whatgov_access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Chat API service
export const chatService = {
  // Send a message to the chat API
  sendMessage: async (message, conversationHistory = [], sessionId = '', token = null) => {
    try {
      // Format the request according to Connect protocol
      const request = {
        message,
        conversation_history: conversationHistory,
        session_id: sessionId
      };
      
      // Set up headers
      const headers = {
        'Content-Type': 'application/json',
        'Connect-Protocol-Version': '1'
      };
      
      // Add token if provided
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      // Make the API call to the Connect endpoint
      const response = await api.post('/whatgov.v1.WhatGovService/Freechat', request, {
        headers
      });
      
      // Return the response data
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }
};

export default api;
